import Vue from 'vue'
import { URL_USER_PROFILE_REQUEST, URL_USER_PROFILE } from '@/constants/urls.js'
import { USER_PROFILE, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [USER_PROFILE.STATE.USER_PROFILE]: {
    inn: null,
    ogrn: null,
    phone: null,
    contactPerson: null,
    // documentPersonIdentity: null,
    subscriptionsStatus: null
  },
  [USER_PROFILE.STATE.REQUEST]: null
}

const actions = {
  async [USER_PROFILE.ACTIONS.GET_USER_PROFILE] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROFILE}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_PROFILE.MUTATIONS.GET_USER_PROFILE, resp.data)
  },
  async [USER_PROFILE.ACTIONS.UPDATE_USER_PROFILE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROFILE}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_PROFILE.MUTATIONS.GET_USER_PROFILE, resp.data)
  },
  async [USER_PROFILE.ACTIONS.GET_USER_REGISTRATION_REQUEST] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROFILE_REQUEST}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_PROFILE.MUTATIONS.GET_USER_REGISTRATION_REQUEST, resp.data)
  },
  async [USER_PROFILE.ACTIONS.SEND_USER_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_PROFILE_REQUEST}`,
      model
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_PROFILE.MUTATIONS.GET_USER_REGISTRATION_REQUEST, resp.data)
  },
  async [USER_PROFILE.ACTIONS.CLEAR_USER_PROFILE] ({ commit }) {
    commit(USER_PROFILE.MUTATIONS.CLEAR_USER_PROFILE)
  },
  async [USER_PROFILE.ACTIONS.CLEAR_USER_REGISTRATION_REQUEST] ({ commit }) {
    commit(USER_PROFILE.MUTATIONS.CLEAR_USER_REGISTRATION_REQUEST)
  }
}

const mutations = {
  [USER_PROFILE.MUTATIONS.GET_USER_PROFILE] (state, userProfile) {
    state[USER_PROFILE.STATE.USER_PROFILE] = userProfile
  },
  [USER_PROFILE.MUTATIONS.MERGE_PROFILE] (state, editedFieldsObj) {
    for (const key in editedFieldsObj) {
      state[USER_PROFILE.STATE.USER_PROFILE][key] = editedFieldsObj[key]
    }
  },
  [USER_PROFILE.MUTATIONS.GET_USER_REGISTRATION_REQUEST] (state, request) {
    state[USER_PROFILE.STATE.REQUEST] = request
  },
  [USER_PROFILE.MUTATIONS.CLEAR_USER_PROFILE] (state) {
    for (const key in state[USER_PROFILE.STATE.USER_PROFILE]) {
      state[USER_PROFILE.STATE.USER_PROFILE][key] = null
    }
  },
  [USER_PROFILE.MUTATIONS.CLEAR_USER_REGISTRATION_REQUEST] (state) {
    state[USER_PROFILE.STATE.REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
